export const FETCH_REST_SETTING_REQUEST = 'FETCH_REST_SETTING_REQUEST';
export const FETCH_REST_SETTING_SUCCESS = 'FETCH_REST_SETTING_SUCCESS';
export const FETCH_REST_SETTING_FAILURE = 'FETCH_REST_SETTING_FAILURE';
export const RESET_STORES = 'RESET_STORES';
